var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { Colors } from '../../../theme';
const CustomTooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, Object.assign({}, props, { classes: { popper: className }, slotProps: { popper: { keepMounted: true, disablePortal: true } } })));
})(() => ({
    [`.${tooltipClasses.popper}& .${tooltipClasses.tooltip}`]: {
        maxWidth: '762px',
        margin: 0,
        padding: 0,
        display: 'flex',
        backgroundColor: Colors.white,
        color: Colors.black80,
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
    },
}));
export default CustomTooltip;
//# sourceMappingURL=index.js.map